import React, { useState, useEffect, use } from   'react';
import { useForm } from 'react-hook-form';
import { Form, Row, Col, FormGroup, Card } from 'react-bootstrap';
import CargandoSpinner from '../Utils/CargandoSpinner';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import SweetAlert2 from 'react-sweetalert2';

const FormularioProyectos = () => {
    const { token, rol } = useAuth();
    const [proyectos, setProyectos] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const [Cargando, setCargando] = useState(false);
    const defaultValues = {
        id: 0,
        str_nombre: '',
        str_observacion: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
                defaultValues: defaultValues
            }
        );
    async function obtenerProyectos() {
        setCargando(true);
        try {
            const response = await apiService.get('/encuestassv/reportes/obtenerproyectos', token);
            setProyectos(response.data);
        } catch (error) {
            console.error('Error al obtener los proyectos de encuesta:', error);
        } finally {
            setCargando(false);
        }
    }

    useEffect(() => {
        obtenerProyectos();
    }, []);

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };

    async function GuardarDatosProyecto(data) {
        setCargando(true);
        try {
            const payload = {
                id: Number(data.id) || 0,
                str_nombre: data.str_nombre,
                str_observacion: data.str_observacion,
            };
            const response = await apiService.post('/encuestassv/reportes/guardarproyecto', payload, token);
            if (response.status === 200) {    
                Mensaje('Éxito', response.data.message);
                reset(defaultValues);
            } else {
                Mensaje('Error', response.data.message);
            }
        } catch (error) {
            console.error('Error al guardar los datos del proyecto:', error);
            Mensaje('Error', 'Ocurrió un error al guardar los datos. Por favor, inténtalo de nuevo.' + (error.response?.data?.message || ''));
        }
        finally {
            setCargando(false);
            obtenerProyectos();
        }
    }
    
    return (
    <Card>
        <Card.Header style={{backgroundColor: '#3c8dbc', color: 'white'}}>
            <h3>Proyecto de encuesta<sup style={{fontSize: '20px'}}></sup></h3>
            <p>Definir proyectos de encuesta para organizar las caracterizaciones</p>
        </Card.Header>
        <Card.Body>
            <CargandoSpinner Cargando={Cargando} />
            {proyectos.length > 0 ? (
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>                                        
                            <tr>
                                <th>id</th>
                                <th>Nombre</th>
                                <th>Observaciones</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {proyectos.map((proyecto) => (
                                <tr key={proyecto.id}>
                                    <td>{proyecto.id}</td>
                                    <td>{proyecto.str_nombre}</td>
                                    <td>{proyecto.str_observacion}</td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-warning"
                                            onClick={() => {
                                                setValue('id', proyecto.id);
                                                setValue('str_nombre', proyecto.str_nombre);
                                                setValue('str_observacion', proyecto.str_observacion);
                                            }}
                                        >
                                            Editar
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p>No hay registros disponibles.</p>
            )}
            <Form onSubmit={handleSubmit(GuardarDatosProyecto)}>
                <Row>
                    <Col md={2}>
                        <FormGroup>
                            <Form.Label htmlFor="id">id</Form.Label>
                            <Form.Control readOnly className="form-control" id="id" placeholder="id" type="text" {...register('id')}>
                            </Form.Control>
                        </FormGroup>
                    </Col> 
                    <Col md={8}>
                        <FormGroup>
                            <Form.Label htmlFor="str_nombre">Nombre</Form.Label>
                            <Form.Control className="form-control" id="str_nombre" placeholder="Nombre" type="text" {...register('str_nombre')}>
                            </Form.Control>
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup>
                            <Form.Label htmlFor="str_observacion">Observaciones</Form.Label>
                            <Form.Control as="textarea" id="str_observacion" className="form-control" rows="3" placeholder="Observaciones" {...register('str_observacion')}></Form.Control>
                        </FormGroup>  
                    </Col> 
                </Row>
                <Row>
                    <Col md={12}>
                        <button type="submit" id="btnproyerase" className="btn btn-primary" >Guardar!</button>
                    </Col>
                </Row>
                </Form>
        </Card.Body>
        <SweetAlert2 {...swalProps} 
            didClose={() => {
                setSwalProps({})
            }}/>
    </Card>

    );
};

export default FormularioProyectos;